<template>
  <v-container>
    <v-content>
      <h1 class="text-center primary--text">Reports</h1>
    </v-content>
    <v-row justify="center" align="center">
      <v-col cols="8">
        <Reports />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import Reports from '../components/reports/Reports.vue'
export default {
  components: {
    Reports
  }
}
</script>
